module.exports = __webpack_public_path__ + "static/media/6.03a4bd1e.svg";